import { render } from "./AnnouncementCreate.vue?vue&type=template&id=0b19bcbf&ts=true"
import script from "./AnnouncementCreate.vue?vue&type=script&lang=ts"
export * from "./AnnouncementCreate.vue?vue&type=script&lang=ts"

import exportComponent from "/data/home/cazaleres/application/cazaleres-owner/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__